import request from "@/utils/request";

// 定时任务
export function test_aps(data) {
    return request({
        url: "/test_aps",
        method: "post",
        data: data,
    });
}
// 添加任务
export function add_aps(data) {
    return request({
        url: "/add_aps",
        method: "post",
        data: data,
    });
}
// 删除任务
export function remove_aps(data) {
    return request({
        url: "/remove_aps",
        method: "post",
        data: data,
    });
}
// 查看任务
export function search_aps(data) {
    return request({
        url: "/search_aps",
        method: "post",
        data: data,
    });
}
// 修改任务
export function update_aps(data) {
    return request({
        url: "/update_aps",
        method: "post",
        data: data,
    });
}
// 任务选择
export function aps_select(data) {
    return request({
        url: "/aps_select",
        method: "post",
        data: data,
    });
}
